module.exports = __webpack_public_path__ + "media/images/ic-servico-cartorio-clicado-2134321eb0f9d0efc1f0a3280e27b182.svg";